import classNames from 'classnames'
import React from 'react'
import {
  ArrowLeft,
  ArrowRight,
  Calendar,
  Camera,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleAlert,
  CircleCheck,
  CircleX,
  Clock,
  CloudOff,
  Download,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileArchive,
  FileText,
  Film,
  Filter,
  Image,
  Info,
  LocateFixed,
  Lock,
  LucideIcon,
  MapPin,
  Maximize2,
  Package,
  Paperclip,
  Pencil,
  Plus,
  Printer,
  QrCode,
  RefreshCw,
  RotateCcw,
  ScanBarcode,
  ScanQrCode,
  ScanText,
  Search,
  Share2,
  Table,
  Trash2,
  TriangleAlert,
  Truck,
  Upload,
  User,
  X,
  ZoomIn,
} from 'lucide-react'

import { UI2IconConfigProps as UI2IconProps } from 'shared-libs/components/ui2/icons/ui2-icon.config'
import {
  UI2_ICON_DEFAULT_SIZE,
  resolveUI2Icon,
} from 'shared-libs/components/ui2/icons/registry'

import './_ui2-icon.scss'

/**
 * Keyed by the `lucide` field of `UI2_ICON_REGISTRY`. Must stay in sync with the
 * registry — `__tests__/ui2-icon-registry.test.ts` fails if they disagree.
 */
export const UI2_LUCIDE_COMPONENTS: Record<string, LucideIcon> = {
  ArrowLeft,
  ArrowRight,
  Calendar,
  Camera,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleAlert,
  CircleCheck,
  CircleX,
  Clock,
  CloudOff,
  Download,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileArchive,
  FileText,
  Film,
  Filter,
  Image,
  Info,
  LocateFixed,
  Lock,
  MapPin,
  Maximize2,
  Package,
  Paperclip,
  Pencil,
  Plus,
  Printer,
  QrCode,
  RefreshCw,
  RotateCcw,
  ScanBarcode,
  ScanQrCode,
  ScanText,
  Search,
  Share2,
  Table,
  Trash2,
  TriangleAlert,
  Truck,
  Upload,
  User,
  X,
  ZoomIn,
}

export const UI2Icon: React.FC<UI2IconProps> = ({ name, size, color, className, style, testID }) => {
  const definition = resolveUI2Icon(name)
  if (!definition) {
    console.warn(`UI2Icon: "${name}" is not in the UI2 icon vocabulary.`)
    return null
  }

  const LucideComponent = UI2_LUCIDE_COMPONENTS[definition.lucide]
  if (!LucideComponent) {
    console.warn(`UI2Icon: no lucide component registered for "${definition.lucide}".`)
    return null
  }

  return (
    <LucideComponent
      size={size ?? UI2_ICON_DEFAULT_SIZE}
      color={color}
      className={classNames('ui2-icon', className)}
      style={style}
      data-testid={testID}
    />
  )
}
